export default function trackGA({ props }) {
    const { eventAction, eventProperties = {} } = props;
    if (window.gtag) {
        window.gtag('event', eventAction, eventProperties); // eslint-disable-line
    }
    if (window._paq) {
        window._paq.push(['trackEvent', 'GRIP kind van', eventAction, eventProperties.event_label ? eventProperties.event_label : '']);
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/app/actions/trackEvent.js